import { SMALL } from 'lib/DeviceScreen';
import { useMedia } from 'react-use';
import Vehicle from 'types/Vehicle';
import MobileSearchResultsCarousel from './MobileSearchResultsCarousel';
import DesktopSearchResultsCarousel from './DesktopSearchResultsCarousel';

interface Props {
  listings: Record<string, any>[];
  onVehicleClick?(vehicle: Vehicle): void;
}

export default function ListingsCarousel({ listings, onVehicleClick }: Props): JSX.Element {
  const shouldRenderMobileCarouselState = useMedia(`(max-width: ${SMALL.cssMaxWidth})`);

  return shouldRenderMobileCarouselState ? (
    <MobileSearchResultsCarousel vehicles={listings} onVehicleClick={onVehicleClick} />
  ) : (
    <DesktopSearchResultsCarousel vehicles={listings} onVehicleClick={onVehicleClick} />
  );
}
